import { Typography } from "@mui/material";
import { FC } from "react";

interface GrammarDateColumnProps {
  date?: string;
}

const GrammarDateColumn: FC<GrammarDateColumnProps> = ({ date }) => {
  if (date) {
    return <Typography>{new Date(date).toLocaleString("fr-FR")}</Typography>;
  }

  return <Typography>-</Typography>;
};

export default GrammarDateColumn;
